<template>
    <b-container>
        
        <b-alert :show="showDismissibleAlert" :variant="variant">{{alertText}}</b-alert>
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        
                <div style="text-align: right;">
                        <label for="" style="color:green;">*payment collected by CeriseTech Solutions Private Limited
</label>
                        </div>
       
        

        <b-row class="justify-content-md-center">
            <b-col md="6" sm="12" class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Receipt</p>
                <p></p>
                <div id="printMe" style="padding: 10px;  
                        border: 2px solid #ddd;
                        border-radius: 15px; text-align:center;display: flex;">
                    <table width="100%" border="1" style="border-collapse: collapse; border: 1px solid #ddd;">
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;" >
                            <td style="border: 1px solid #ddd" width="50%">
                            Name
                            </td>
                            <td style="border: 1px solid #ddd" >{{form.UserName}}</td>
                        </tr>

                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd"  width="50%">
                            Application Number
                            </td>
                            <td style="border: 1px solid #ddd" >{{form.ApplicationNo}} </td>
                            
                        </tr>

                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">
                            Transaction ID
                            </td>
                            <td style="border: 1px solid #ddd" >{{form.UserPaymentID}} </td>
                        </tr>
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">
                            Transaction Referance Number
                            </td>
                            <td style="border: 1px solid #ddd" >{{form.TransacstionRefNum}} </td>
                            
                        </tr>
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">
                                Amount*
                            </td>
                            <td style="border: 1px solid #ddd" >&#8377;{{form.TransactionAmount}}</td>
                        </tr>
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">
                                Payment Towards
                            </td>
                            <td style="border: 1px solid #ddd" >{{form.TransactionType}} </td>
                        </tr>
                        <tr style="height:30px; text-align:Left; font-size: 0.875rem;">
                            <td style="border: 1px solid #ddd" width="50%">Date</td>
                            <td style="border: 1px solid #ddd" >{{form.TransactionDate}} </td>
                        </tr>
                        <tr style="height:30px; text-align:center; font-size: 0.875rem;" v-if="form.TransactionStatus =='Credit'">
                            <td style="border: 1px solid #ddd" colspan="2">Payment Successful!</td>
                        </tr>
                        <tr style="height:30px; text-align:center; font-size: 0.875rem;" v-if="form.TransactionStatus =='Refunded'">
                            <td style="border: 1px solid #ddd color:red" colspan="2">Payment Refunded</td>
                        </tr>  
                        <tr style="height:30px; text-align:center; font-size: 1rem;" v-if="form.TransactionStatus !='Credit'">
                            <td style="border: 1px solid #ddd color:red" colspan="2">ERROR IN PROCESSING YOUR REQUEST.</td>
                        </tr>                     
                </table>  
                
                </div>
               
                
                <b-btn variant="success" class="float-right mt-2 mr-2" size="sm" v-print>Print Receipt</b-btn>
                <b-btn variant="secondary" class="float-right mt-2 mr-2" size="sm" @click="goBack" v-if="showback">Back</b-btn>
                <br>
                 
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";

export default {
  props: ["payment_id", "payment_request_id"],
  components: { Spinner },
  data() {
    return {
      isLoading: true,
      showDismissibleAlert: true,
      showback: false,
      variant: "info",
      alertText: "Please wait while we check the payment status.",
      form: {
        TransactionStatus: "",
        TransactionDate: "",
        TransactionAmount: 0,
        TransacstionRefNum: "",
        TransactionType: "",
        UserName: "",
        ErrorMessage: "",
        UserPaymentID: ""
      },
      applicantName: "--",
      transactionId: "--",
      applicationId: "--",
      transactionReferenceNumber: "--",
      Amount: 0.0,
      Service: "--",
      transactionDate: "--",
      pmtMessage: "--",
      pmtStatus: "Success",
      show: false
    };
  },
  methods:{
      goBack(){
          this.$router.go(-1);
      }
  },
  mounted() {
    if (!this.$store.getters.getPrintPmt) {
      let localinfo = localStorage.getItem("userinfo");

      if (!localinfo) {
        this.$router.replace("/");
        return;
      }
      var userinfol = JSON.parse(localinfo);
      var token = localStorage.getItem("token");

      this.$store.dispatch("login", {
        token: token,
        user: userinfol
      });
      this.showback = false;
    } else {
      this.showback = true;
    }

    var userinfo = this.$store.getters.loggedUser;
    if (!this.payment_id || !this.payment_request_id || !userinfo.UserId) {
      this.$router.replace("/");
      return;
    }

    //var userinfo = this.$store.getters.loggedUser;

    let payload = {
      UserID: userinfo.UserId,
      PaymentID: this.payment_id,
      PaymentRequestID: this.payment_request_id
    };
    let promise = apis.ReadPaymentStatusInsta(payload);

    promise
      .then(response => {
        if (response.status == 200) {
          this.form = response.body;
          this.isLoading = false;
          if (this.form.TransactionStatus == "Credit") {
            this.alertText = "Payment Successful";
          } else if (this.form.TransactionStatus == "Refunded") {
            this.alertText = "Payment Refunded";
          } else {
            this.alertText = this.form.ErrorMessage;
          }
          this.show = true;
        } else {
          this.alertText =
            "Unable to confirm the Payment Status as Server contact is lost";

          this.variant = "warning";
          this.showDismissibleAlert = true;
          this.isLoading = false;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PaymentConfirmInstaM.vue